<template>
	<div>
		<div class="jiben" id="print">
			<div class="title">
				<span><input value="某某律师事务所" style="text-align: center;border: none;"/></span>
				<span>收案审批表</span>
			</div>
			<div style="margin-top: 10px;">
				<table class="table table-hover">
					<tbody>
						<tr>
							<td class="tdleft" width="15%">委托方(人)</td>
							<td width="35%">{{detail.priority}}</td>
							<td class="tdleft" width="15%">法定代表人</td>
							<td width="35%"></td>
						</tr>
						<tr>
							<td class="tdleft" width="15%">地址</td>
							<td width="35%"></td>
							<td class="tdleft" width="15%">联系电话</td>
							<td width="35%">{{detail.telephone}}</td>
						</tr>
						<tr>
							<td class="tdleft" width="15%">对方当事人</td>
							<td colspan="3"></td>
						</tr>
						<tr>
							<td class="tdleft" width="15%">案由</td>
							<td colspan="3" style="text-align: center;">{{detail.anyou}}</td>
						</tr>
						<tr>
							<td class="tdleft" width="15%" rowspan="2">涉案标的</td>
							<td width="35%" rowspan="2"></td>
							<td class="tdleft" width="15%" rowspan="2">收费方式</td>
							<td width="35%">
								<el-checkbox v-model="ashoufei">固定收费</el-checkbox>
								数额__________元
							</td>
						</tr>
						<tr>
							<td>
								<el-checkbox v-model="bshoufei">风险代理</el-checkbox>
								基础________+_____%提成
							</td>
						</tr>
						<tr>
							<td class="tdleft" width="15%" rowspan="2">付款期限</td>
							<td width="35%" colspan="3">
								<el-checkbox v-model="cshoufei">签约即付</el-checkbox>
							</td>
						</tr>
						<tr>
							<td colspan="3">
								其他：________________________________________
							</td>
						</tr>
						<tr>
							<td class="tdleft" width="15%">案件来源</td>
							<td colspan="3">
								<el-radio v-model="origin" label="自有案源">自有案源</el-radio>
								<el-radio v-model="origin" label="交办案件">交办案件</el-radio>
								<el-radio v-model="origin" label="案源库案件">案源库案件</el-radio>
							</td>
						</tr>
						<tr>
							<td class="tdleft" width="15%" rowspan="3">案件来源</td>
							<td colspan="2">
								诉讼风险告知：
								<el-radio v-model="gaozhi" label="已告知">已告知</el-radio>
								<el-radio v-model="gaozhi" label="未告知">未告知</el-radio>
							</td>
							<td colspan="1"  rowspan="3" style="position: relative;">
								<div style="position: absolute;top: 10px;left: 5px">审查人签名：</div>
								<div style="position: absolute;bottom: 5px;right: 5px">__________年__________月__________日</div>
							</td>
						</tr>
						<tr>
							<td colspan="2">
								利益冲突审查：
								<el-radio v-model="shencha" label="已审查">已审查</el-radio>
								<el-radio v-model="shencha" label="未审查">未审查</el-radio>
							</td>
						</tr>
						<tr>
							<td colspan="2">
								重大群体性敏感案件：
								<el-radio v-model="qunti" label="是">是</el-radio>
								<el-radio v-model="qunti" label="否">否</el-radio>
							</td>
						</tr>
						<tr>
							<td class="tdleft" width="15%">承办律师意见</td>
							<td colspan="3">
								<div style="height: 150px;"></div>
								<div style="text-align: right;">
									<span style="padding-right: 125px;">律师签名：</span>
									__________年__________月__________日
								</div>
							</td>
						</tr>
						<tr>
							<td class="tdleft" width="15%">负责人意见</td>
							<td colspan="3">
								<div style="height: 150px;"></div>
								<div style="text-align: right;">
									<span style="padding-right: 125px;">负责人签名：</span>
									__________年__________月__________日
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div style="margin:10px;text-align: right;">
			<el-button type="primary" v-print="printObj">打印</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			detail: {
				type: Object,
				default: () => {
					return {}
				}
			},
		},
		data() {
			return {
				ashoufei:false,
				bshoufei:false,
				cshoufei:false,
				origin:false,
				gaozhi:false,
				shencha:false,
				qunti:false,
				printObj: {
					id: "print",    // 这里是要打印元素的ID
					popTitle: '',  // 打印的标题
					extraCss: '/styles/print.css',  // 打印可引入外部的一个 css 文件
					extraHead: ''  // 打印头部文字
				},
			}
		},
		mounted() {
			console.log(this.detail);
		},
		methods: {
			
		}
	}
</script>

<style scoped>
	.jiben {
		padding: 10px;
		background-color: #fff;
	}
	.table{
		width: 100%;
		font-size: 12px !important;
	}
	
	.table td {
		vertical-align: middle;
		/* padding: 15px 10px; */
		line-height: 19px;
		border: 1px solid #EEEEEE;
		white-space: pre-wrap;
		word-break: break-all;
	}
	.table td.tdleft {
		text-align: center;
		background: #f6faff;
	}
	.table tr:hover {
		background: #f6faff;
	}
	.title{
		display: flex;
		padding:10px 0;
		font-size: 19px;
		font-weight: bold;
		justify-content: center;
		align-items: center;
	}
	/deep/ .el-checkbox__label {
		font-size: 12px !important;
	}
	/deep/ .el-radio__label {
		font-size: 12px !important;
	}
</style>